import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { AbortiveExplainStatus } from '../../../enums/AbortiveExplainStatus'
import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AbortiveExplainUpdateButtonProps } from './interface'

export const AbortiveExplainUpdateButton = ({
  record
}: AbortiveExplainUpdateButtonProps) => {
  const { user } = useAuthStore(state => pick(state, ['user']))
  const hasPermission = user.defaultProfileId === record.explainCreatorProfileId

  const {
    setCurrentAuction,
    setAbortiveExplainFormMode,
    toggleAbortiveExplainVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'setCurrentAuction',
      'setAbortiveExplainFormMode',
      'toggleAbortiveExplainVisible'
    ])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    setAbortiveExplainFormMode(FormMode.UPDATE)
    toggleAbortiveExplainVisible(true)
  }

  return hasPermission &&
    record.explainStatus === AbortiveExplainStatus.AUDIT_FAIL &&
    record.status === AuctionOperationPageStatus.DEAL_FAIL ? (
    <Button type='link' onClick={handleClick}>
      修改说明
    </Button>
  ) : null
}
